import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { SettingsControllerModule } from './controllers/SettingsController';
import { SettingsFieldsView } from './fields/fields';
import { SettingsIntegrationView } from './integration/integration';
import { SettingsModalsFieldsView } from './modals/fields/fields';
import { SettingsTerminalsView } from './terminals/terminals';

export const SettingsView = angular
  .module('acme.view.application.settings', [
    uiRouter,
    'ui.bootstrap',
    SettingsControllerModule,
    SettingsIntegrationView,
    SettingsTerminalsView,
    SettingsFieldsView,
    SettingsModalsFieldsView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.settings',
      url: '/settings',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'SettingsController',
          templateUrl: 'views/application/views/settings/settings.tpl.html',
        },
      },
    });
  }).name;
